import { render } from "./ProspectAiHelper.vue?vue&type=template&id=99be32fe"
import script from "./ProspectAiHelper.vue?vue&type=script&lang=js"
export * from "./ProspectAiHelper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__